import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { adminService } from '@/api/services/adminService'

// Define initial state
const initialState = {
  roles: [] as { id: string; name: string }[], // Ensure `roles` is always an array
  loading: false,
  error: null as string | null,
};

// Async thunk for fetching roles
export const fetchRoles = createAsyncThunk('roles/fetchRoles', async () => {
  try {
    const response = await adminService.roleAll();
    console.log("API Response:", response.data); // Debugging output
    return response.data.data; // Extract only the `data` array
  } catch (error) {
    console.error("Error fetching roles:", error);
    throw new Error('Failed to fetch roles');
  }
});

const roleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    resetRoleState: () => initialState, // Now `initialState` is defined
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Redux Payload (Fixed):", action.payload); // Should be an array
        state.roles = action.payload || []; // Ensure it's an array
      })                     
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to fetch roles';
      });
  },
});

export default roleSlice.reducer;
export const { resetRoleState } = roleSlice.actions; // Export actions
